export default [
    {
        name: 'name',
        title: '<span class="orange glyphicon glyphicon-user"></span>Shop name'
    },
    {
        name: 'address.country',
        title: 'Country'
    },
    {
        name: 'address.city',
        title: 'City'
    },
    {
        name: 'iconURL',
        formatter: value => `<img style="width: auto; height: 50px" src=${value}>`,
        title: 'Icon'
    },
    'actions'
];